import React, { Component } from 'react';
import Top from './Top';
import './index.css';
import './PremiumHome.css';
import ProductReduct from './ProductReduce';
import Serve from './Serve';
import Connect from './Connect';
import Bottom from './Bottom';
import News from './News';

class PremiumHome extends Component {
    componentDidMount() {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
    }

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <div className="premium-home">
                <div className="hero-section">
                    <div className="hero-video-wrapper">
                        <video 
                            className="hero-video" 
                            preload="auto" 
                            loop 
                            playsInline 
                            autoPlay
                            src="https://www.gtcygz.cn/static/media/qrs.mp4"
                            tabIndex={"-1"} 
                            muted="muted"
                        >
                        </video>
                        <div className="hero-overlay"></div>
                    </div>
                    <div className="hero-content">
                        <div className="container">
                            <h1 className="hero-title">嵌入式系统设计原理与应用</h1>
                            <p className="hero-subtitle">探索前沿技术，培养创新思维，打造未来工程师。本课程旨在使学生了解嵌入式系统微机的基本原理，掌握硬件结构、内部资源、指令系统、应用程序设计和应用系统组成等多方面知识。</p>
                            <div className="hero-actions">
                                <button className="btn btn-primary">了解更多</button>
                                <button className="btn btn-outline">查看项目</button>
                            </div>
                        </div>
                    </div>
                    <Top />
                </div>

                <div className="section">
                    <div className="container">
                        <ProductReduct />
                    </div>
                </div>

                <div className="section section-alternate">
                    <div className="container">
                        <Serve />
                    </div>
                </div>

                <div className="section">
                    <div className="container">
                        <News />
                    </div>
                </div>

                <div className="section section-alternate">
                    <div className="container">
                        <Connect />
                    </div>
                </div>

                <Bottom />
            </div>
        );
    }
}

export default PremiumHome;
